import React, { Fragment, Component } from 'react';
import '../App.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.getImageURL = this.getImageURL.bind(this);
  }

  getImageURL() {
    // TODO: Make this return a new URL every n seconds
    return `${process.env.PUBLIC_URL}/images/Header.jpg`;
  }

  render() {
    return (
      <Fragment>
        <div className="row boaa-header">
          <div className="col-lg-7 col-md-12 col-xs-12 col-sm-12">
            <img className="header-side-image" src={this.getImageURL()} alt="Ann Arbor" />
          </div>
          <div className="header-text col-lg-5 ">
            <div className="header-text-year">2019</div>
            <div className="dividing-line" />

            <div className="header-text-title">
            Student of
              {' '}
              <br />
              {' '}
            the Year
            </div>

            <div className="header-text-description">
              <span> Oftentimes, the strongest leaders on campus accomplish so much with little recognition, preferring humility over hubris. However, we here at The Statement believe in highlighting students creating change and making this university a better place. This class of Students of the Year have made incredible strides in diversity, acceptance and inclusivity. The students were recommended by other students on campus and selected by Statement staff for their dedication, accomplishments and positive attitudes. From founders of organizations to promote cultural diversity to creators of art and social change, these students are truly the Leaders and Best. 
              </span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}


export default Header;